export const theme = {
  colors: {
    primary: '#F1AF59', // 柔和橘黄
    secondary: '#FFFFFF', // 白色
    text: '#333333', // 深灰文字
    background: '#F8F8F8', // 浅灰背景
  },
  fonts: {
    main: "'Roboto', sans-serif",
  },
};

/**
 * 单一断点来源 —— 全站统一用这里的值，避免散落的 768/800/960/1024 等魔法数字。
 * phone: 手机（页面内容主断点）
 * tablet: 平板/iPad（导航汉堡、PDF 查看器全屏等已用此断点）
 */
export const breakpoints = {
  phone: 768,
  tablet: 1024,
};

/** 直接拼进 styled-components 模板里的媒体查询前缀 */
export const media = {
  phone: `@media (max-width: ${breakpoints.phone}px)`,
  tablet: `@media (max-width: ${breakpoints.tablet}px)`,
};

/** 布局尺寸（固定导航高度、家长端底部标签栏高度） */
export const layout = {
  navbarHeight: 56,
  bottomNavHeight: 60,
};

/** 统一的层级，避免各弹窗/导航 z-index 互相打架（1000/1001/2000 混用） */
export const zLayers = {
  navbar: 1000,
  bottomNav: 1000,
  dropdown: 1100,
  modalOverlay: 2000,
  modal: 2001,
  /**
   * 挂在控件上的浮层（SearchableSelect 的选项菜单）。菜单渲染到 body，必须盖过打开它的弹窗 ——
   * 测试模块的老弹窗用的是 2500，所以这里留足余量。
   */
  popover: 5000,
};
